var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeautyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9001 15.933C19.7869 15.4987 22.0001 13.0078 22.0001 10C22.0001 6.68629 19.3138 4 16.0001 4C12.6864 4 10.0001 6.68629 10.0001 10C10.0001 13.0078 12.2133 15.4987 15.1001 15.933V19.1H12.9001C12.403 19.1 12.0001 19.5029 12.0001 20C12.0001 20.4971 12.403 20.9 12.9001 20.9H19.1001C19.5972 20.9 20.0001 20.4971 20.0001 20C20.0001 19.5029 19.5972 19.1 19.1001 19.1H16.9001V15.933ZM20.2001 10C20.2001 12.3196 18.3197 14.2 16.0001 14.2C13.6805 14.2 11.8001 12.3196 11.8001 10C11.8001 7.6804 13.6805 5.8 16.0001 5.8C18.3197 5.8 20.2001 7.6804 20.2001 10Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52634 4.26988C7.76103 4.43904 7.9001 4.7107 7.9001 5V10.1H8.1501C8.56431 10.1 8.9001 10.4358 8.9001 10.85V17.5C8.9001 19.3778 7.37787 20.9 5.5001 20.9C3.62233 20.9 2.1001 19.3778 2.1001 17.5V10.85C2.1001 10.4358 2.43588 10.1 2.8501 10.1H3.1001V6C3.1001 5.61261 3.34798 5.26869 3.71549 5.14619L6.71549 4.14619C6.98995 4.0547 7.29165 4.10073 7.52634 4.26988ZM6.1001 6.24868V10.1H4.9001V6.64868L6.1001 6.24868ZM3.9001 11.9H7.1001V17.5C7.1001 18.3837 6.38375 19.1 5.5001 19.1C4.61644 19.1 3.9001 18.3837 3.9001 17.5V11.9Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyOutline);
export default __webpack_public_path__ + "static/media/beauty_outline.193662a9b7622130e009ad5c8873743f.svg";
export { ForwardRef as ReactComponent };